import React from 'react';

const PrivacyComponent = () => {
  return (
    <div className='w-full text-xl'>
      <main className="pt-8 pb-16 lg:pt-16 lg:pb-24 bg-white dark:bg-gray-900 antialiased">
        <div className="flex justify-between">
          <article className="mx-auto w-full sm:max-w-4xl lg:max-w-5xl format format-sm sm:format-base lg:format-lg format-blue dark:format-invert">
            <header className="mb-4 lg:mb-6 not-format text-center">
              <h1 className="mb-4 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                PRIVACY POLICY
              </h1>
              <h4 className="text-lg font-semibold"> Last Update: November 28, 2023</h4>
            </header>
            <p className="lead my-8 text-xl">
              Agal Software Solutions Limited (“we,” “our,” or “us”) is committed to protecting your privacy. This
              Privacy Policy explains how your personal information is collected, used, and disclosed by Agal Software
              Solutions.
            </p>
            <p className='text-xl'>
              This Privacy Policy applies to our website, and its associated subdomains (collectively, our “Service”)
              alongside our application, agalsoftwaresolutions.com. By accessing or using our Service, you signify that
              you have read, understood, and agree to our collection, storage, use, and disclosure of your personal
              information as described in this Privacy Policy and our Terms of Service.
            </p>

            <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
              Definitions and key terms
            </h2>
            <div>
              <ul>
                <li className="my-4 list-disc text-xl">
                  Cookie: small amount of data generated by a website and saved by your web browser. It is used to
                  identify your browser, provide analytics, remember information about you such as your language
                  preference or login information.
                </li>
                <li className="my-4 list-disc text-xl">
                  Company: when this policy mentions “Company,” “we,” “us,” or “our,” it refers to Agal Software
                  Solutions, (Portmore St. Catherine Jamaica), that is responsible for your information under this
                  Privacy Policy
                </li>
                <li className="my-4 list-disc text-xl">
                  Country: where agalsoftwaresolutions.com or the owners/founders of agalsoftwaresolutions.com are
                  based, in this case is Jamaica
                </li>
                <li className="my-4 list-disc text-xl">
                  Customer: refers to the company, organization or person that signs up to use the
                  agalsoftwaresolutions.com Service to manage the relationships with your consumers or service users.
                </li>
                <li className="my-4 list-disc text-xl">
                  Device: any internet connected device such as a phone, tablet, computer or any other device that can
                  be used to visit agalsoftwaresolutions.com and use the services.
                </li>
                <li className="my-4 list-disc text-xl">
                  IP address: Every device connected to the Internet is assigned a number known as an Internet protocol
                  (IP) address. These numbers are usually assigned in geographic blocks. An IP address can often be used
                  to identify the location from which a device is connecting to the Internet
                </li>
                <li className="my-4 list-disc text-xl">
                  Personnel: refers to those individuals who are employed by agalsoftwaresolutions.com or are under
                  contract to perform a service on behalf of one of the parties.
                </li>
                <li className="my-4 list-disc text-xl">
                  Personal Data: any information that directly, indirectly, or in connection with other information —
                  including a personal identification number — allows for the identification or identifiability of a
                  natural person.
                </li>
                <li className="my-4 list-disc text-xl">
                  Personal Data: any information that directly, indirectly, or in connection with other information —
                  including a personal identification number — allows for the identification or identifiability of a
                  natural person.
                </li>
                <li className="my-4 list-disc text-xl">
                  Third-party service: refers to advertisers, contest sponsors, promotional and marketing partners, and
                  others who provide our content or whose products or services we think may interest you.
                </li>
                <li className="my-4 list-disc text-xl">
                  Website: Agal Software Solutions site, which can be accessed via this URL:
                  www.agalsoftwaresolutions.com
                </li>
                <li className="my-4 list-disc text-xl">
                  You: a person or entity that is registered with agalsoftwaresolutions.com to use the Services
                </li>
              </ul>
            </div>
            <div>
              <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                Information automatically collected
              </h2>
              <div className="text-xl my-4">
                There is some information like your Internet Protocol (IP) address and/or browser and device
                characteristics — is collected automatically when you visit our platform. This information may be used
                to connect your computer to the Internet. Other information collected automatically could be a login,
                e-mail address, password, computer and connection information such as browser plug-in types and versions
                and time zone setting, operating systems and platforms, purchase history, (we sometimes aggregate with
                similar information from other Users), the full Uniform Resource Locator (URL) clickstream to, through
                and from our website that may include date and time; cookie number; parts of the site you viewed or
                searched for; and the phone number you used to call our Customer Services. We may also use browser data
                such as cookies, Flash cookies (also known as Flash Local Shared Objects) or similar data on certain
                parts of our website for fraud prevention and other purposes. During your visits, we may use software
                tools such as JavaScript to measure and collect session information including page response times,
                download errors, length of visits to certain pages, page interaction information (such as scrolling,
                clicks, and mouse-overs), and methods used to browse away from the page. We may also collect technical
                information to help us identify your device for fraud prevention and diagnostic purposes.
              </div>
              <div className="text-xl">
                We automatically collect certain information when you visit, use or navigate the platform. This
                information does not reveal your specific identity (like your name or contact information) but may
                include device and usage information, such as your IP address, browser and device characteristics,
                operating system, language preferences, referring URLs, device name, country, location, information
                about who and when you use our and other technical information. This information is primarily needed to
                maintain the security and operation of our platform, and for our internal analytics and reporting
                purposes.
              </div>
            </div>

            <div>
              <div>
                <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                  Personnel
                </h2>
                <p className="text-xl">
                  If you are a agalsoftwaresolution worker or applicant, we collect information you voluntarily provide
                  to us. We use the information collected for Human Resources purposes in order to administer benefits
                  to workers and screen applicants.
                </p>
                <p className="text-xl">
                  You may contact us in order to (1) update or correct your information, (2) change your preferences
                  with respect to communications and other information you receive from us, or (3) receive a record of
                  the information we have relating to you. Such updates, corrections, changes and deletions will have no
                  effect on other information that we maintain, or information that we have provided to third parties in
                  accordance with this Privacy Policy prior to such update, correction, change or deletion.
                </p>
              </div>
            </div>

            <div>
              <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                Your Consent
              </h2>
              <p className="text-xl">
                We've updated our Privacy Policy to provide you with complete transparency into what is being set when
                you visit our site and how it's being used. By using our agalsoftwaresolutions.com, registering an
                account, or making a purchase, you hereby consent to our Privacy Policy and agree to its terms.
              </p>
            </div>

            <div>
              <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                Links to Other Websites
              </h2>
              <p className="text-xl">
                This Privacy Policy applies only to the Services. The Services may contain links to other websites not
                operated or controlled by agalsoftwaresolutions.com. We are not responsible for the content, accuracy or
                opinions expressed in such websites, and such websites are not investigated, monitored or checked for
                accuracy or completeness by us. Please remember that when you use a link to go from the Services to
                another website, our Privacy Policy is no longer in effect. Your browsing and interaction on any other
                website, including those that have a link on our platform, is subject to that website’s own rules and
                policies. Such third parties may use their own cookies or other methods to collect information about
                you.
              </p>
            </div>

            <div>
              <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                Cookies
              </h2>
              <p className="text-lg">
                Agalsoftwaresolutions uses "Cookies" to identify the areas of our website that you have visited. A
                Cookie is a small piece of data stored on your computer or mobile device by your web browser. We use
                Cookies to enhance the performance and functionality of our website but are non-essential to their use.
                However, without these cookies, certain functionality like videos may become unavailable or you would be
                required to enter your login details every time you visit the website as we would not be able to
                remember that you had logged in previously. Most web browsers can be set to disable the use of Cookies.
                However, if you disable Cookies, you may not be able to access functionality on our website correctly or
                at all. We never place Personally Identifiable Information in Cookies.
              </p>
            </div>
            <div>
              <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                Blocking and disabling cookies and similar technologies
              </h2>
              <p className="text-xl">
                Wherever you're located you may also set your browser to block cookies and similar technologies, but
                this action may block our essential cookies and prevent our website from functioning properly, and you
                may not be able to fully utilize all of its features and services. You should also be aware that you may
                also lose some saved information (e.g. saved login details, site preferences) if you block cookies on
                your browser. Different browsers make different controls available to you. Disabling a cookie or
                category of cookie does not delete the cookie from your browser, you will need to do this yourself from
                within your browser, you should visit your browser's help menu for more information.
              </p>
            </div>

            <div>
              <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                Kids' Privacy
              </h2>
              <p className="text-xl">
                We do not address anyone under the age of 13. We do not knowingly collect personally identifiable
                information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your
                child has provided Us with Personal Data, please contact Us. If We become aware that We have collected
                Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to
                remove that information from Our servers.
              </p>
            </div>

            <div>
              <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                Use of Information
              </h2>
              <ul>
                <li className="my-4 list-disc text-lg">Your information shall be used for the following purposes:</li>
                <li className="my-4 list-disc text-lg">
                  To communicate with you if applicable, and provide you with notifications;
                </li>
                <li className="my-4 list-disc text-xl">
                  To comply with applicable legislation, regulations and any legal and regulatory requirements;
                </li>
                <li className="my-4 list-disc text-xl">
                  To identify you and facilitate your transactions (where applicable);
                </li>
                <li className="my-4 list-disc text-xl">
                  {' '}
                  For marketing purposes. We will not share your information with third parties for their marketing
                  purposes; and
                </li>
                <li className="my-4 list-disc text-lg">
                  To assist with the Site development, analysis, assessing patterns of use and for providing user
                  assistance.
                </li>
              </ul>
            </div>

            <div>
              <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                Third-Party Services
              </h2>
              <p className="text-xl py-4">
                {' '}
                We may display, include or make available third-party content (including data, information, applications
                and other products services) or provide links to third-party websites or services ("Third- Party
                Services").
              </p>
              <p className="text-xl">
                You acknowledge and agree that agalsoftwaresolutions.com shall not be responsible for any Third-Party
                Services, including their accuracy, completeness, timeliness, validity, copyright compliance, legality,
                decency, quality or any other aspect thereof. agalsoftwaresolutions.com does not assume and shall not
                have any liability or responsibility to you or any other person or entity for any Third-Party Services.
              </p>
              <p className="text-xl">
                Third-Party Services and links thereto are provided solely as a convenience to you and you access and
                use them entirely at your own risk and subject to such third parties' terms and conditions.
              </p>
            </div>

            <div>
              <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                Information about General Data Protection Regulation (GDPR)
              </h2>
              <p className="text-xl py-4">
                We may be collecting and using information from you if you are from the European Economic Area (EEA),
                and in this section of our Privacy Policy we are going to explain exactly how and why is this data
                collected, and how we maintain this data under protection from being replicated or used in the wrong
                way.
              </p>
              <p className="text-xl">
                You acknowledge and agree that agalsoftwaresolutions.com shall not be responsible for any Third-Party
                Services, including their accuracy, completeness, timeliness, validity, copyright compliance, legality,
                decency, quality or any other aspect thereof. agalsoftwaresolutions.com does not assume and shall not
                have any liability or responsibility to you or any other person or entity for any Third-Party Services.
              </p>
              <p className="text-xl">
                Third-Party Services and links thereto are provided solely as a convenience to you and you access and
                use them entirely at your own risk and subject to such third parties' terms and conditions.
              </p>
            </div>

            <div>
              <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                What is personal data?
              </h2>
              <p className="text-xl">
                Any data that relates to an identifiable or identified individual. GDPR covers a broad spectrum of
                information that could be used on its own, or in combination with other pieces of information, to
                identify a person. Personal data extends beyond a person’s name or email address. Some examples include
                financial information, political opinions, genetic data, biometric data, IP addresses, physical address,
                sexual orientation, and ethnicity.
              </p>
            </div>

            <div>
              <h3 className="my-8 text-xl font-medium">
                {' '}
                The Data Protection Principles include requirements such as:
              </h3>
              <li className="my-4 list-disc text-lg">
                Personal data collected must be processed in a fair, legal, and transparent way and should only be used
                in a way that a person would reasonably expect.
              </li>
              <li className="my-4 list-disc text-lg">
                Personal data should be held no longer than necessary to fulfil its purpose.
              </li>
              <li className="my-4 list-disc text-lg">
                Personal data should be held no longer than necessary to fulfil its purpose.
              </li>
              <li className="my-4 list-disc text-lg">
                People covered by the GDPR have the right to access their own personal data. They can also request a
                copy of their data, and that their data be updated, deleted, restricted, or moved to another
                organization.
              </li>
            </div>

            <div>
              <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                Why is GDPR important?
              </h2>
              <p className="text-xl">
                GDPR adds some new requirements regarding how companies should protect individuals' personal data that
                they collect and process. It also raises the stakes for compliance by increasing enforcement and
                imposing greater fines for breach. Beyond these facts it's simply the right thing to do. At
                agalsoftwaresolutions.com we strongly believe that your data privacy is very important and we already
                have solid security and privacy practices in place that go beyond the requirements of this new
                regulation.
              </p>
            </div>

            <div>
              <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                Individual Data Subject's Rights - Data Access, Portability and Deletion
              </h2>
              <p className="text-xl py-4">
                We are committed to helping our customers meet the data subject rights requirements of GDPR.
                agalsoftwaresolutions.com processes or stores all personal data in fully vetted, DPA compliant vendors.
                We do store all conversation and personal data for up to 6 years unless your account is deleted. In
                which case, we dispose of all data in accordance with our Terms of Service and Privacy Policy, but we
                will not hold it longer than 60 days.
              </p>
              <p className="text-xl">
                We are aware that if you are working with EU customers, you need to be able to provide them with the
                ability to access, update, retrieve and remove personal data. We got you! We've been set up as self
                service from the start and have always given you access to your data and your customers data. Our
                customer support team is here for you to answer any questions you might have about working with the API.
              </p>
            </div>

            <div>
              <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                Contact Us
              </h2>
              <p className="py-4">Don't hesitate to contact us if you have any questions.</p>
              <ul className="text-xl font-bold">
                <li>Via Email: info@agalsoftwaresolutions.com</li>
                <li>Via this Link: www.agalsoftwaresolutions.com</li>
              </ul>
            </div>
          </article>
        </div>
      </main>
    </div>
  );
};

export default PrivacyComponent;
